import * as React from "react";
const SvgCheckmark = (props) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13 24L4 15L5.414 13.586L13 21.171L26.586 7.586L28 9L13 24Z", fill: "#FEFCF6" }));
export default SvgCheckmark;
